import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './parent-routes';
import Login from '@phrmpc/modules/auth/pages/Login';

const authParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_auth',
});

const loginRoute = createRoute({
  getParentRoute: () => authParentRoute,
  path: 'auth/login',
  component: Login,
  validateSearch: (search: Record<string, unknown>): { redirectTo?: string } => ({
    redirectTo:
      typeof search.redirectTo === 'string' ? search.redirectTo : undefined,
  }),
});

export const authRouteTree = authParentRoute.addChildren([loginRoute]);
